export const modalState = {
  hidden: true,
  data: {
    title: "",
    description: "",
    date: "",
    image: "",
    list: [],
    tools: [],
  },
};